const xdiff = new THREE.Vector2(), ydiff = new THREE.Vector2();
const d = new THREE.Vector2();

/**
 * 
 * @param {THREE.Line3} line1 
 * @param {THREE.Line3} line2 
 */
function intersectLines(line1, line2, out) {
    const denominator = ((line2.end.y - line2.start.y) * (line1.end.x - line1.start.x)) - ((line2.end.x - line2.start.x) * (line1.end.y - line1.start.y));

    if (denominator === 0) return null;

    const distA = line1.start.y - line2.start.y;
    const distB = line1.start.x - line2.start.x;

    const numerator1 = ((line2.end.x - line2.start.x) * distA) - ((line2.end.y - line2.start.y) * distB);
    const numerator2 = ((line1.end.x - line1.start.x) * distA) - ((line1.end.y - line1.start.y) * distB);

    const a = numerator1 / denominator;
    const b = numerator2 / denominator;

    if (!(a > 0 && a < 1) || !(b > 0 && b < 1))
        return null;

    const x = line1.start.x + (a * (line1.end.x - line1.start.x));
    const y = line1.start.y + (a * (line1.end.y - line1.start.y));

    return out ? out.set(x, y) : new THREE.Vector2(x, y);
}

export default intersectLines;
export { intersectLines };

function determinant(a, b) { return a.x * b.y - a.y * b.x; }